export default __webpack_public_path__ + "static/media/plus.7a58c046.png";